$(document).ready(function () {
	$(window).on('scroll', function () {
		var scrollPos = $(document).scrollTop(); // Adjust the scroll position by subtracting 60
		$('.section').each(function () {
			var currLink = $(this);
			var refElement = $(currLink);
			if (refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
				$('#menu ul li a').removeClass("active");
				$('#menu ul li a[href="#' + currLink.attr('id') + '"]').addClass("active");
			}
		});
	});
});



//AHW scroll down
$('.fixed-menu').onePageNav({
	currentClass: 'current',
	changeHash: false,
	scrollSpeed: 750,
	scrollThreshold: 0.5,
	filter: '',
	easing: 'swing',
	begin: function () {
		//I get fired when the animation is starting
	},
	end: function () {
		//I get fired when the animation is ending
	},
	scrollChange: function ($currentListItem) {
		//I get fired when you enter a section and I pass the list item of the section
	}

});



// Get the video element

window.onload = function () {
	var video = document.querySelector('video');
	var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

	if (isMobile) {
		video.setAttribute('playsinline', '');
		video.setAttribute('muted', '');
	}

	video.play();
};


$(function () {

	//----- OPEN
	$('[data-popup-open]').on('click', function (e) {
		var targeted_popup_class = $(this).attr('data-popup-open');
		$('[data-popup="' + targeted_popup_class + '"]').fadeIn(350);

		e.preventDefault();
	});

	//----- CLOSE
	$('[data-popup-close]').on('click', function (e) {
		var targeted_popup_class = $(this).attr('data-popup-close');
		$('.popup').fadeOut(350);
		e.preventDefault();
	});

	// Close popup when clicking outside of .popup-inner
	$(document).on('click', function (e) {
		if ($(e.target).closest('.popup-inner').length === 0 && $(e.target).closest('[data-popup-open]').length === 0) {
			$('.popup').fadeOut(350);
		}
	});

});




// timer

(function ($) {
	$.fn.countTo = function (options) {
		options = options || {};

		return $(this).each(function () {
			// set options for current element
			var settings = $.extend({}, $.fn.countTo.defaults, {
				from: $(this).data('from'),
				to: $(this).data('to'),
				speed: $(this).data('speed'),
				refreshInterval: $(this).data('refresh-interval'),
				decimals: $(this).data('decimals')
			}, options);

			// how many times to update the value, and how much to increment the value on each update
			var loops = Math.ceil(settings.speed / settings.refreshInterval),
				increment = (settings.to - settings.from) / loops;

			// references & variables that will change with each update
			var self = this,
				$self = $(this),
				loopCount = 0,
				value = settings.from,
				data = $self.data('countTo') || {};

			$self.data('countTo', data);

			// if an existing interval can be found, clear it first
			if (data.interval) {
				clearInterval(data.interval);
			}
			data.interval = setInterval(updateTimer, settings.refreshInterval);

			// initialize the element with the starting value
			render(value);

			function updateTimer() {
				value += increment;
				loopCount++;

				render(value);

				if (typeof (settings.onUpdate) == 'function') {
					settings.onUpdate.call(self, value);
				}

				if (loopCount >= loops) {
					// remove the interval
					$self.removeData('countTo');
					clearInterval(data.interval);
					value = settings.to;

					if (typeof (settings.onComplete) == 'function') {
						settings.onComplete.call(self, value);
					}
				}
			}

			function render(value) {
				var formattedValue = settings.formatter.call(self, value, settings);
				$self.html(formattedValue);
			}
		});
	};

	$.fn.countTo.defaults = {
		from: 0,               // the number the element should start at
		to: 0,                 // the number the element should end at
		speed: 1000,           // how long it should take to count between the target numbers
		refreshInterval: 100,  // how often the element should be updated
		decimals: 0,           // the number of decimal places to show
		formatter: formatter,  // handler for formatting the value before rendering
		onUpdate: null,        // callback method for every time the element is updated
		onComplete: null       // callback method for when the element finishes updating
	};

	function formatter(value, settings) {
		return value.toFixed(settings.decimals).replace(/\B(?=(?:\d{3})+(?!\d))/g, ',');
	}
}(jQuery));

$(window).on('scroll', function () {
	$('.count-number').each(function () {
		if (isElementInViewport($(this)) && !$(this).hasClass('counted')) {
			$(this).addClass('counted');
			count.call(this);
		}
	});
});

function isElementInViewport(el) {
	var rect = el[0].getBoundingClientRect();
	return (
		rect.top >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
	);
}

function count() {
	var $this = $(this);
	var options = $.extend({}, $this.data('countToOptions') || {});
	$this.countTo(options);
}

//Teams Slider

$(document).ready(function () {
	$('.person-items').slick({
		speed: 300,
		autoplay: true,
		dots: false,
		rows: 1,
		infinite: false,
		slidesToShow: 4,
		slidesToScroll: 4,
		arrows: true,
		lazyLoad: 'ondemand',
		prevArrow: '<div class="a-right control-c prev slick-prev slick-arrow" style=""><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" height="15px"><path d="M224 480c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l169.4 169.4c12.5 12.5 12.5 32.75 0 45.25C240.4 476.9 232.2 480 224 480z"></path></svg></div>',
		nextArrow: '<div class="a-right control-c next slick-next slick-arrow" style=""><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" height="15px"><path d="M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z"></path></svg></div>',
		responsive: [
			{
				breakpoint: 1025,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					dots: true,
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					dots: true,
				}
			}
		]
	});
});


//partners Slider

$(document).ready(function () {
	$('.partners-boxs').slick({
		speed: 300,
		autoplay: true,
		dots: false,
		rows: 2,
		infinite: false,
		slidesToShow: 5,
		slidesToScroll: 5,
		arrows: true,
		lazyLoad: 'ondemand',
		prevArrow: '<div class="a-right control-c prev slick-prev slick-arrow" style=""><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" height="15px"><path d="M224 480c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l169.4 169.4c12.5 12.5 12.5 32.75 0 45.25C240.4 476.9 232.2 480 224 480z"></path></svg></div>',
		nextArrow: '<div class="a-right control-c next slick-next slick-arrow" style=""><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" height="15px"><path d="M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z"></path></svg></div>',
		responsive: [
			{
				breakpoint: 1025,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					arrows: false,
					dots: false,
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					arrows: false,
					dots: false,
				}
			}
		]
	});
});

